import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

import Default from "./layouts/Default.vue";
import FullWidth from "./layouts/FullWidth.vue";
import Members from "./layouts/Members.vue";
import Bookings from "./layouts/Bookings.vue";
import Applications from "./layouts/Applications.vue";
import Billing from "./layouts/Billing.vue";
import Tickets from "./layouts/Tickets.vue";
import Activities from "./layouts/Activities.vue";
import Notes from "./layouts/Notes.vue";
Vue.component('default-layout', Default);
Vue.component('fullwidth-layout', FullWidth);
Vue.component('members-layout', Members);
Vue.component('bookings-layout', Bookings);
Vue.component('applications-layout', Applications);
Vue.component('billing-layout', Billing);
Vue.component('tickets-layout', Tickets);
Vue.component('activities-layout', Activities);
Vue.component('notes-layout', Notes);

import './../node_modules/bulma/css/bulma.css';

// Import the Auth0 configuration
//import { domain, clientId, audience } from "../auth_config.json";
import { domain, clientId, audience } from "../auth0_config.js";

// Import the plugin here
import { Auth0Plugin } from "./auth";

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});

// Global functions
Vue.mixin({
  methods: {
    async getAccessToken() {
      this.accessToken = await this.$auth.getTokenSilently()
    },
  },
})

// Filter to format a MySQL date into the UK format for display
Vue.filter('formatUKDate', function (value) {
  if (!value) return '';

  const date = new Date(value);

  const day = ('0' + date.getDate()).slice(-2);
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const year = date.getFullYear();

 // const hours = ('0' + date.getHours()).slice(-2);
 // const mins = ('0' + date.getMinutes()).slice(-2);
 // return `${day}/${month}/${year} ${hours}:${mins}`;

 
  return `${day}/${month}/${year}`;
});

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
